import {InjectionToken} from '@angular/core';

import LANG_RU_TRANS from '../../../../../../../public/i18n/admin/ru.json';
import LANG_EN_TRANS from '../../../../../../../public/i18n/admin/en.json';

// Временный фикс. Удаляю переводы с unicode символом 2028, из-за которого падает ошибка
delete LANG_RU_TRANS['dashboard']['domains']['reg manual']['intro'];
delete LANG_RU_TRANS['constructor']['orderForm']['def']['phone example'];
delete LANG_EN_TRANS['dashboard']['domains']['reg manual']['intro'];
delete LANG_EN_TRANS['constructor']['orderForm']['def']['phone example'];

// translation token
export const TRANSLATIONS = new InjectionToken('translations');

// all translations
export const dictionary = {
  ['ru']: LANG_RU_TRANS,
  ['en']: LANG_EN_TRANS,
  ['pt-BR']: LANG_RU_TRANS,
  ['ro']: LANG_RU_TRANS,
  ['pl']: LANG_RU_TRANS,
  ['tr']: LANG_RU_TRANS,
};

// providers
export const TRANSLATION_PROVIDERS = [
  { provide: TRANSLATIONS, useValue: dictionary }
];
